import {
  CFDropCheckoutPayment,
  CFEnvironment,
  CFSession,
  CFThemeBuilder,
} from "cashfree-pg-api-contract";
import { v4 as uuidv4 } from "uuid";
import Colors from "../../../assets/Color/Colors";
import { globalConst } from "../../../utils/globalConstant";
import {
  hideLoader,
  showLoader,
} from "../../../commonComponents/Loader/loader.actions";
import { Network } from "../../../utils/network";
import { Platform } from "react-native";
import { walletImport } from "../walletImports";

export const tripleARecharge = async (res) => {
  // console.log(res);
  var link = res?.hosted_url;
  const viewport =
    Platform.OS === "ios"
      ? '<meta name="viewport" content="initial-scale=0.7,minimum-scale=0.8,maximum-scale=0.8" />'
      : "";

  let innerHTML =
    '<iframe  id="triplea-payment-form" src=' +
    link +
    ' width="100%" height="1111" style="flex-grow: 1;" allowfullscreen></iframe>';
  var a = `
                  <!DOCTYPE html>
                  <html>
                    <head>
                   ${viewport}
                    </head>
                    <body>
                      <div style="display:flex">${innerHTML}</div>
                      <script>
                    
                        window.addEventListener('message', e => {
                          if(e.data==='triplea.paymentSuccess'){
                            window?.ReactNativeWebView?.postMessage(e.data);
                          }
                          
                         
                        }, false);
                     
                      </script>
                    </body>
                  </html>
            `;

  return a;
  // setHtmlLink(a);
  // setTripleALink(link);
};

export const initiate_payload = {
  requestId: uuidv4,
  service: "in.juspay.hyperpay",
  payload: {
    action: "initiate",
    merchantId: "tradexapp",
    clientId: "tradexapp",
    environment: "production",
  },
};

export const initJuspay = () => {};

export const config = {
  headers: {
    version: globalConst.appVersion,
  },
};

var x = 1;

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const waitMethod = async (order_id, juspayStatus, status, dispatch) => {
  await delay(500);
  x++;
  fetchJuspayStatus(order_id, juspayStatus, status, dispatch);
};

export const fetchJuspayStatus = async (
  order_id,
  juspayStatus,
  status,
  dispatch
) => {
  const data = {
    orderId: order_id,
  };
  dispatch(showLoader());
  const res = await Network.fetchJuspay(data);
  if (!res?.data?.success) {
    dispatch(hideLoader());
    var amount = res?.data?.amount || 0;
    var msg =
      "Request cancelled. Your request for adding funds was incomplete.";
    var title = "Payment failed";
    juspayStatus(amount, msg, false, "", title);
  } else {
    if (res?.data?.message && res?.data?.message === "pending") {
      var amount = res?.data?.amount;

      if (x === 2) {
        dispatch(hideLoader());
        x = 1;
        var msg =
          "Request cancelled. Your request for adding funds was incomplete.";
        var title = "Payment failed";
        juspayStatus(amount, msg, false, "", title);
      } else {
        waitMethod(order_id, juspayStatus, status, dispatch);
      }
    } else if (res?.data?.message && res?.data?.message === "failed") {
      dispatch(hideLoader());
      var amount = res?.data?.amount;
      var msg =
        "Request cancelled. Your request for adding funds was incomplete.";
      switch (status) {
        case "backpressed":
          msg = "Transaction has been cancelled by user. Please try again";
          break;
        case "user_aborted":
          msg = "Transaction has been cancelled by user. Please try again";
          break;
        case "pending_vbv":
          break;
        case "authorizing":
          break;
        case "authorization_failed":
          msg =
            "Your transaction has been declined due to invalid details. Please try again";
          break;
        case "authentication_failed":
          msg =
            "Your transaction has been declined due to invalid details. Please try again";
          break;
        case "api_failure":
          break;
        case "new":
          break;
        default:
          break;
      }
      var title = "Payment failed";
      juspayStatus(amount, msg, false, "", title);
    } else {
      dispatch(hideLoader());
      var transaction = res?.data?.transactions;
      var amount = res?.data?.amount;
      var transactionId = transaction[0]?.txnid;
      var msg = "Added Successfully";
      // Network.addPayment(res);
      var title = "Payment successful";
      juspayStatus(amount, msg, true, transactionId, title);
    }
  }
};

export const onMetaStatusHandling = (status, watchamount, navigation) => {
  var statusObj = {
    isShow: true,
    status: status,
    amount: watchamount,
    isDeposit: true,
  };
  switch (status) {
    case "fiatPending":
    case "fiatReceived":
    case "orderReceived":
    case "transferred":
    case "refundInitiated":
    case "completed":
      statusObj = {
        ...statusObj,
        title: "Payment Processing!",
        msg: "Your transaction is currently processing.",
        paymentIsInProgress: true,
      };
      break;
    case "completed":
      statusObj = {
        ...statusObj,
        title: "Payment Success!",
        msg: "Your deposit of ₹9995 has been processed against transaction ID DFSE3434E.",
      };
      break;
    case "expired":
      statusObj = {
        ...statusObj,
        status: false,
        title: "Payment Expired!",
        msg: "Your deposit has been expired. If you have already transferred funds, please retry again with same details & if error persists please contact us .",
      };
      break;
    case "refunded":
      statusObj = {
        ...statusObj,
        title: "Payment Refunded!",
        msg: "Your bank details seems to be invalid. Any funds deducted has already been refunded to the source account.",
      };
      break;
    case "cancelled":
      statusObj = {
        ...statusObj,
        title: "Payment Cancelled!",
        msg: "Your deposit has been cancelled. Please try again.",
        status: false,
      };
      break;
    default:

    // console.log(data);
  }
  navigation.push("WalletStack", {
    screen: "WalletStatus",
    params: { paymentStatus: statusObj },
  });
};
